import { useContext, useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import { SmartContext } from "../../../../library/Core/SmartContext";
import ActionSettings from "../../../../library/SimpleControls/ActionSettings";
import { axiosClient } from "../../../../library/Service/axiosClient";
import { Link, useParams } from "react-router-dom";
import NoteFormModal from "./NoteFormModal";
import SessionContext from "../../../../library/Core/SessionContext";
import moment from "moment";
import { REPORT_CONFIG } from "../../../admin/reports/report-config";

const CounsellorNotes = () => {
    const { state, dispatch } = useContext(SmartContext);
    const { sessionState }: any = useContext(SessionContext);

    const model = state.internal.model;
    const { id, pageName } = useParams();
    const config = REPORT_CONFIG?.[state.routeInfo?.pageName] ?? {};
    const [notesList, setnotesList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [description, setDescription] = useState('');
    const [editingNote, setEditingNote] = useState<any>(null);

    const [errors, setErrors] = useState<{ description: string }>({
        description: '',
    });

     useEffect(() => {
        getNotes();
     }, []);
   
    const getNotes = async () => {
        try {
            const response = await axiosClient().get(
            `${process.env.REACT_APP_BAS_API}/pace/getNotes?studentId=${model?.id}`
            );
            if (response.data.success) {
            console.log("notesList", response.data.data);
            setnotesList(response.data.data); 
            } else {
            setnotesList([]);
            }
        } catch (error) {
            console.error('Error fetching PACE form:', error);
            toast.error("Failed to fetch notes");
        }
        };
    

    const getValidActions = (isActive: number) => {
        const actions = config['ROW_ACTION'];
        console.log("actions",actions)
        return actions.filter((item: any) => item !== (isActive == 1 ? 'ACTIVATE' : 'DEACTIVATE'));
    };

    const getActionNode = (row: any) => {
        const actions = config['ROW_ACTION'];
        console.log("actions.length",actions)
        return actions.length > 1 ? (
            <ActionSettings id={row} actions={getValidActions(row?.isActive)} onClick={handleAction} />
        ) : (
            <a className="btn-update" href={config['UPDATE_ACTION_LINK'](row.student_id)} target="_blank" rel="noopener noreferrer">
                Update
            </a>
        );
    };
    const handleAction = (row: any, action: string) => {
        console.log(row,action)
        handlePerformAction(action,row)
    }

    const handleDelete=(id:number,status:number)=>{
        const msg=(status==1) ? 'Are you sure you want to Deactivate this record?' : 'Are you sure you want to Activate this record?';
        const isConfirmed = window.confirm(msg);
        if (isConfirmed) {
            deleteDomainData(id,status);
        }
    }

    const deleteDomainData = async (id: number,status:number) => {
    try {
        const response = await axiosClient().get(`${process.env.REACT_APP_BAS_API}/pace/delete-note/${id}/${status}`);
        const data = response.data;
        const toastMessage = (status === 1) ? 'Deactivated successfully' : 'Activated successfully';
        if (data.success) {
            toast.success(toastMessage);
            await getNotes();  
        }
    } catch (error) {
        console.error('Error deleting data:', error);
        alert(error);
    }
    };

    const handlePerformAction = async (action: string, row: any) => {
        switch (action) {
            case 'DEACTIVATE':
                handleDelete(row.id,row.isActive);
                break;
            case 'ACTIVATE':
                handleDelete(row.id,row.isActive);
                break;
           case 'UPDATE':
                addNotes(row);
                break;
        }
    };

   const addNotes = (row: { id: number; note: string } | null = null) => {
        if (row) {
            setDescription(row.note);
            setEditingNote(row.id);
        } else {
            setDescription('');
            setEditingNote(null);
        }
        dispatch({ type: 'TOGGLE_MODAL_VISIBILITY', payload: { modalName: 'addCounsellorNotes' } });
    };


   const handleAddNote = async () => {
    const newErrors = { description: '' };

    if (!description.trim()) {
        newErrors.description = 'Please fill the description field.';
    } else if (description.trim().length > 1000) {
        newErrors.description = 'Description must not exceed 1000 characters.';
    }

    setErrors(newErrors);
    // If any error is present, return early
    if (Object.values(newErrors).some((error) => error)) {
        return;
    }

    try {
        setLoading(true);
        const payload: any = {
            studentId: model?.id,
            description: description.trim(),
            createdBy: sessionState?.id,
        };

        if (editingNote) {
            payload.id = editingNote;
        }

        const response = await axiosClient().post(
            `${process.env.REACT_APP_BAS_API}/pace/saveNotes`,
            payload
        );

        if (response.data.success) {
            toast.success(response.data.message); 
            dispatch({ type: 'TOGGLE_MODAL_VISIBILITY', payload: { modalName: 'addCounsellorNotes' } });
            await getNotes();
        } else {
            toast.error(response.data.message || 'Something went wrong');
        }

    } catch (error) {
        toast.error('Failed to save note');
        console.error(error);
    } finally {
        setLoading(false);
    }
   };


return (
        <>
            <div>
                <div className="counselling-lists">
                    <div className="tab-white-block mb-2 p-0 overflow-hidden border">
                        <div className="d-flex flex-wrap flex-column flex-md-row">
                            <div
                                className="nav flex-row flex-md-column nav-pills custom-sub-tab ps-3 py-3"
                                id="v-pills-tab"
                                role="tablist"
                                aria-orientation="vertical">
                                    <Link className="nav-link" to={`/alumni/${id}/profile/counselling`}>Psychometric Tests </Link>
                                    <Link className="nav-link" to={`/alumni/${id}/profile/sessions`}>Sessions</Link>
                                    <Link className="nav-link" to={`/alumni/${id}/profile/counselling-logs`}>Counselling Logs</Link>
                                    <Link className="nav-link" to={`/alumni/${id}/profile/communication-logs`} >Communication Logs</Link>
                                    <Link className="nav-link active" to={`/alumni/${id}/profile/counsellor-notes`} >Communication Notes</Link>
                            </div>
                            <div className="tab-content p-3 p-sm-4 p-md-5 bg-gray-F2F4F7 width-cal-191" id="v-pills-tabContent">
                             
                                <div
                                    className="tab-pane fade fade active show"
                                    id="v-pills-counsellor-notes"
                                    role="tabpanel"
                                    aria-labelledby="v-pills-counsellor-notes-tab">
                                    <div className="d-flex justify-content-end mb-4">
                                        <button className="btn btn-primary mb-2" onClick={() => addNotes()}>Add Notes</button>
                                    </div>
                                    <div className="table-responsive attendee_dtl min-h-280">
                                        <table className="table lite-blue-header" style={{ minWidth: 845 }}>
                                            <thead>
                                                <tr>
                                                    <th>Description</th>
                                                    <th>Added On</th>
                                                    <th>Added By</th>
                                                    <th>Status</th>
                                                    <th>Action</th>
                                                    
                                                </tr>
                                            </thead>
                                        <tbody>
                                        {Array.isArray(notesList) && notesList.length > 0 ? (
                                            notesList.map((row: any) => (
                                                <tr key={row.id}>
                                                    <td width={'450'}>{row.note}</td>
                                                    <td><span className="date">{moment(row.createdAt).format('DD-MMM-YYYY')}</span> 
                                                    </td>
                                                    <td>{row.created_by_name}</td>
                                                    <td style={{ color: (row.isActive as boolean) ? 'green' : 'red' }}>  
                                                    {(row.isActive as boolean) ? 'Active' : 'De-active'}</td>
                                                    <td>{getActionNode(row)}</td>
                                                </tr>
                                            ))
                                            ) : (
                                            <tr>
                                                <td colSpan={5} className="text-center">No notes found.</td>
                                            </tr>
                                            )}
                                        </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
           <NoteFormModal
            data={{
                description,
                setDescription,
                handleAddNote,
                errors,
                editingNote
            }}
            />
        </>
    );
}

export default CounsellorNotes;